/**
 * Builds the flag-icons CSS class list for an ISO 3166-1 alpha-2 country code.
 * Returns an empty string for a blank code so callers can hide the flag.
 *
 * @param {string} code -- alpha-2 country code (e.g. "BR"); case-insensitive
 * @returns {string} the flag-icons class list (e.g. "fi fi-br"), or "" when no code
 */
export const flagClassName = (code) => (code ? `fi fi-${code.toLowerCase()}` : '');

const FLAG_BASE_CLASS = 'devise-form-wrapper__flag';

const applyFlag = (flagElement, code) => {
  if (!flagElement) return;

  const className = code
    ? `${FLAG_BASE_CLASS} ${flagClassName(code)}`
    : `${FLAG_BASE_CLASS} ${FLAG_BASE_CLASS}_empty`;
  flagElement.setAttribute('class', className);
};

const bindFlag = (selectId, flagId) => {
  const select = document.getElementById(selectId);
  const flag = document.getElementById(flagId);
  if (!select || !flag) return;

  const sync = () => applyFlag(flag, select.value);
  select.addEventListener('change', sync);
  sync();
};

/**
 * Shows the selected country's flag beside each country control on the
 * registration form. Residence and phone carry independent country selections,
 * so each flag tracks its own dropdown. No-ops when the controls are absent.
 */
export const initCountryFlag = () => {
  bindFlag('country_code', 'country_flag');
  bindFlag('phone_country', 'phone_flag');
};
